import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { DEVICE_FEATURE_KEY } from './keys';
import { deviceReducer } from './reducers/device.reducer';
import { DeviceEffects } from './effects/device.effects';
import { DeviceReauthBridge } from './bridges/device_reauth.bridge';

export function provideDeviceStore(): EnvironmentProviders[] {
    return [provideState(DEVICE_FEATURE_KEY, deviceReducer), provideEffects(DeviceEffects, DeviceReauthBridge)];
}
